<template>
    <div>
        <!--<div style="overflow:auto; height:100vh; background-color:white;">-->
        <!-- <div style="overflow:auto; height:100vh; background-color:#fc6512;">
            <img :src="require('@/assets/position_landing.jpg')" style="width:100%;" @click="goToInstallLink">
        </div> -->
    </div>
</template>

<script>
    import {WEB_PLATFORM_TYPE} from "../../Constants";

    export default {
        name: "SharePositionLanding",
        methods : {
            goToInstallLink(){
                const platForm = this.$Util.getWebPlatForm();
                if(platForm === WEB_PLATFORM_TYPE.ANDROID){
                    window.open('https://play.google.com/store/apps/details?id=com.ubiplus.custom.obyungear_user')
                }else if(platForm === WEB_PLATFORM_TYPE.IOS){
                    window.open('https://itunes.apple.com/app/id6443870201');
                }
            },
        },
        created(){
            this.$GlobalStore.addModal('MyPositionPro', {transitionName : '', originallyPosition: 'CM', isLanding: true})
        }
    }
</script>

<style scoped>

</style>